import { put, get } from './utils';

export async function getByIdNotificationAlertApi(data) {
  return get(`/admin/centre-app-settings/notifications-alerts`, data);
}

export async function enableNotificationAndAlertForCentresApi(data) {
  return put(`/admin/centre-app-settings/notifications-alerts`, data);
}
